import Form from "@/components/Form";
import Router from 'next/router'
import { useState } from "react";
import Text from "@/components/LanguageResolver";

export default function Register() {

	const [formErrors, setFormErrors] = useState<{username: string, password: string, email: string, _password: string}>({username: '', password: '', email: '', _password: ''});

  	function submitLogin(data) 
	{
		setFormErrors({username: '', password: '', email: '', _password: ''});

		fetch("/api/user/register", {
			method: 'POST',
			headers: {
				'content-type': 'application/json',
				'accept': 'application/json'
			},
			body: JSON.stringify(data),
		}).then((re) => re.json()).then((data) => {
			console.log(data);
			const status = data.status;

			if (status != 200) {
				let errorEntries = Object.entries(data.errors);

				setFormErrors({
					username: ((errorEntries.find((e) => e[0].toLowerCase() == 'username')?.[1] ?? '') + "").split(',')[0],
					password: ((errorEntries.find((e) => e[0].toLowerCase() == 'password')?.[1] ?? '') + "").split(',')[0],
					email: ((errorEntries.find((e) => e[0].toLowerCase() == 'email')?.[1] ?? '') + "").split(',')[0],
					_password: ((errorEntries.find((e) => e[0].toLowerCase() == '_password')?.[1] ?? '') + "").split(',')[0]
				});

				(document.getElementById('form_button') as HTMLInputElement).checked = false;
			}
			else {
				Router.push('/user/login');
			}
		});
	}

    return (
        <div className="container">
        <Form title="Register" submitText="Register" onSubmit={submitLogin}>

            <p>Username</p>
            <input spellCheck={false} autoComplete="false" name="username"/>
			<div id="username_error"><Text val={formErrors.username} /></div>

            <p>Email</p>
            <input spellCheck={false} autoComplete="false" name="email"/>
			<div id="email_error"><Text val={formErrors.email} /></div>

            <p>Password</p>
            <input spellCheck={false} autoComplete="false" name="password" type="password"/>
			<div id="password_error"><Text val={formErrors.password} /></div>

            <p>Repeat password</p>
            <input spellCheck={false} autoComplete="false" name="_password" type="password"/>
			<div id="password_error"><Text val={formErrors._password} /></div>
        </Form>
      </div>
    )
  }
  